// Build 20260909-324: axis preferences and canonical keyboard movement.
(() => {
  const match = location.pathname.match(/\/products\/([^/?#]+)/);
  if (!window.SmoofProductProfiles?.isTestProfile?.(match?.[1])) return;
  if (window.__smoofAlignmentGuidesV235Build324) return;
  window.__smoofAlignmentGuidesV235Build324 = true;
  window.__smoofAlignmentGuidesV235 = true;
  window.__smoofAlignmentGuidesV234 = true;
  window.__smoofAlignmentGuidesV233 = true;
  window.__smoofAlignmentGuidesV232 = true;
  window.__smoofAlignmentGuidesV231 = true;
  window.__smoofAlignmentGuidesV230 = true;
  window.__smoofAlignmentGuidesV229 = true;

  const PRINT_RADIUS = 0.3534;
  const PRINT_EDGE = 0.5 - PRINT_RADIUS;
  const DEFAULT_QR_SIZE = 0.256;
  const QR_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0996/4136/0721/files/Placeholder_config7.png?v=1785497532';
  // Measured alpha bounds of the immutable placeholder: [617, 617, 983, 983]
  // on a 1600-square source. Keep the panel/production reservation canonical.
  const QR_ARTWORK_SIZE = 366 / 1600;
  const QR_FRAME_BORDER = 1.5;
  const QR_SOURCE_MARKERS = ['Placeholder_config7', '1785497532'];
  const THRESHOLD = 0.012;
  // View preferences deliberately stay outside QR/design/history state.
  const snapAxes = { x: true, y: true };
  const axisEnabled = axis => snapAxes[axis] !== false;
  function setAxisEnabled(axis, enabled) {
    if (axis !== 'x' && axis !== 'y') return false;
    snapAxes[axis] = Boolean(enabled);
    if (!snapAxes[axis]) axis === 'x' ? hideX() : hideY();
    window.dispatchEvent(new CustomEvent('smoof:snap-preferences-changed', {
      detail: { ...snapAxes }
    }));
    return snapAxes[axis];
  }
  const PROPERTY_NAMES = {
    x: 'properties[_SMOOF QR X]',
    y: 'properties[_SMOOF QR Y]',
    scale: 'properties[_SMOOF QR Skalierung]',
    visible: 'properties[_SMOOF QR sichtbar]',
    codeColor: 'properties[_SMOOF QR Farbe]',
    backingVisible: 'properties[_SMOOF QR Hintergrund sichtbar]',
    backingColor: 'properties[_SMOOF QR Hintergrund Farbe]'
  };
  const state = {
    x: 0.5,
    y: 0.5,
    scale: 1,
    visible: true,
    codeColor: '#000000',
    backingVisible: true,
    backingColor: '#FFFFFF'
  };
  let overlay = null;
  let lineX = null;
  let lineY = null;
  let safeZoneRing = null;
  let currentStage = null;
  let qrFrame = null;
  let qrImage = null;
  let dragging = false;
  let dragMoved = false;
  let dragStart = null;
  let selected = false;
  let suppressionTimer = null;
  let guideVisibilityObserver = null;
  let observedGuideVisibilityButton = null;

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  function normalizeColor(value, fallback = '#FFFFFF') {
    const compact = String(value || '').trim().replace(/^#/, '');
    if (/^[0-9a-f]{3}$/i.test(compact)) {
      return `#${compact.split('').map(character => character + character).join('')}`.toUpperCase();
    }
    return /^[0-9a-f]{6}$/i.test(compact)
      ? `#${compact}`.toUpperCase()
      : fallback;
  }

  function storedBoolean(name, fallback) {
    const raw = String(propertyInput(name)?.value || '').trim().toLowerCase();
    if (['ja', 'yes', 'true', '1', 'sichtbar', 'visible'].includes(raw)) return true;
    if (['nein', 'no', 'false', '0', 'aus', 'hidden'].includes(raw)) return false;
    return fallback;
  }

  function profileForcesTransparentBacking() {
    return document.documentElement.dataset.smoofQrBackground === 'transparent';
  }

  function laserForcesBlackQr() {
    return document.documentElement.dataset.smoofForceMonochromeLaser === 'true' &&
      currentVariant()?.printProcess === 'laser';
  }

  function currentVariant() {
    return window.SmoofProductVariant?.get?.() || null;
  }

  function configuredLaserMarginMm() {
    const profileValue = Number(
      window.SmoofProductProfiles?.current?.editorPolicy?.laserEdgeMarginMm
    );
    const datasetValue = Number(document.documentElement.dataset.smoofLaserEdgeMarginMm);
    const value = Number.isFinite(profileValue) ? profileValue : datasetValue;
    return Math.max(0, Number.isFinite(value) ? value : 0);
  }

  function activeLaserMarginMm() {
    return currentVariant()?.printProcess === 'laser'
      ? configuredLaserMarginMm()
      : 0;
  }

  function currentDiameterMm() {
    const variantDiameter = Number(currentVariant()?.diameterMm);
    const profileDiameter = Number(window.SmoofProductProfiles?.current?.defaults?.diameterMm);
    return Math.max(1, Number.isFinite(variantDiameter) ? variantDiameter : (profileDiameter || 80));
  }

  /*
   * PRINT_RADIUS bildet den physischen Produktradius ab. Der Sicherheitsrand
   * wird deshalb proportional zum aktuell gewählten Durchmesser normalisiert.
   * 80 mm und 1,5 mm ergeben z. B. 0,3401475 statt 0,3534.
   */
  function activePrintRadius() {
    const normalizedMargin = PRINT_RADIUS * (activeLaserMarginMm() * 2 / currentDiameterMm());
    return Math.max(0.01, PRINT_RADIUS - normalizedMargin);
  }

  function activePrintEdge() {
    return 0.5 - activePrintRadius();
  }

  function guideVisibilityButton() {
    return document.querySelector('[data-smoof-guide-visibility-button]');
  }

  function guidesVisible() {
    const button = guideVisibilityButton();
    return button?.dataset.active === 'true' || button?.getAttribute('aria-pressed') === 'true';
  }

  function observeGuideVisibility() {
    const button = guideVisibilityButton();
    if (button === observedGuideVisibilityButton) return;
    guideVisibilityObserver?.disconnect();
    guideVisibilityObserver = null;
    observedGuideVisibilityButton = button;
    if (!button) return;
    guideVisibilityObserver = new MutationObserver(updateSafeZoneRing);
    guideVisibilityObserver.observe(button, {
      attributes: true,
      attributeFilter: ['data-active', 'aria-pressed']
    });
  }

  function productForm() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(form =>
      form.querySelector('button[type="submit"]')
    ) || null;
  }

  function propertyInput(name) {
    return Array.from((productForm() || document).querySelectorAll('input')).find(input =>
      input.name === name && input.type !== 'file'
    ) || null;
  }

  function setProperty(name, value) {
    const form = productForm();
    if (!form) return;
    let input = propertyInput(name);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = String(value);
  }

  function loadState() {
    const x = Number.parseFloat(propertyInput(PROPERTY_NAMES.x)?.value);
    const y = Number.parseFloat(propertyInput(PROPERTY_NAMES.y)?.value);
    const scale = Number.parseFloat(propertyInput(PROPERTY_NAMES.scale)?.value);
    state.x = Number.isFinite(x) ? x : 0.5;
    state.y = Number.isFinite(y) ? y : 0.5;
    state.scale = Number.isFinite(scale) ? clamp(scale, 0.5, 1.5) : 1;
    state.visible = storedBoolean(PROPERTY_NAMES.visible, true);
    state.codeColor = normalizeColor(
      propertyInput(PROPERTY_NAMES.codeColor)?.value,
      '#000000'
    );
    state.backingVisible = profileForcesTransparentBacking()
      ? false
      : storedBoolean(PROPERTY_NAMES.backingVisible, true);
    state.backingColor = normalizeColor(
      propertyInput(PROPERTY_NAMES.backingColor)?.value,
      '#FFFFFF'
    );
    constrainState();
  }

  function saveState() {
    setProperty(PROPERTY_NAMES.x, state.x.toFixed(5));
    setProperty(PROPERTY_NAMES.y, state.y.toFixed(5));
    setProperty(PROPERTY_NAMES.scale, state.scale.toFixed(3));
    setProperty(PROPERTY_NAMES.visible, state.visible ? 'Ja' : 'Nein');
    setProperty(PROPERTY_NAMES.codeColor, state.codeColor);
    setProperty(PROPERTY_NAMES.backingVisible, state.backingVisible ? 'Ja' : 'Nein');
    setProperty(PROPERTY_NAMES.backingColor, state.backingColor);
    document.documentElement.dataset.smoofQrVisible = String(state.visible);
    document.documentElement.dataset.smoofQrCodeColor = state.codeColor;
    document.documentElement.dataset.smoofQrBackingVisible = String(state.backingVisible);
    document.documentElement.dataset.smoofQrBackingColor = state.backingColor;
  }

  function stage() {
    return document.querySelector('.po-livePreview-stage .konvajs-content');
  }

  function qrSize() { return DEFAULT_QR_SIZE * state.scale; }

  function configuredBackingVisible() {
    return !profileForcesTransparentBacking() && state.backingVisible;
  }

  function backingVisible() {
    return state.visible && configuredBackingVisible();
  }

  function backingColor() {
    return normalizeColor(state.backingColor, '#FFFFFF');
  }

  function codeColor() {
    return normalizeColor(state.codeColor, '#000000');
  }

  function renderedCodeColor() {
    return laserForcesBlackQr() ? '#000000' : codeColor();
  }

  function qrBounds(padding = 0) {
    const half = qrSize() / 2;
    const extra = Number.isFinite(Number(padding)) ? Number(padding) : 0;
    return {
      left: state.x - half - extra,
      right: state.x + half + extra,
      top: state.y - half - extra,
      bottom: state.y + half + extra,
      width: qrSize() + extra * 2,
      height: qrSize() + extra * 2,
      centerX: state.x,
      centerY: state.y,
      scale: state.scale
    };
  }

  // Object exclusion follows the visible panel/artwork, in canonical units.
  // Keep qrBounds/getState/sizeMm as the stable panel/export geometry. Never
  // derive persistent constraints from viewport size or browser border rounding.
  function qrProtectionBounds(padding = 0) {
    const bounds = qrBounds(padding);
    if (configuredBackingVisible()) return bounds;
    const inset = (DEFAULT_QR_SIZE - QR_ARTWORK_SIZE) * state.scale / 2;
    return {
      ...bounds,
      left: bounds.left + inset, right: bounds.right - inset,
      top: bounds.top + inset, bottom: bounds.bottom - inset,
      width: bounds.width - inset * 2, height: bounds.height - inset * 2
    };
  }

  function squareFits(x, y, half, radius = activePrintRadius()) {
    return [
      [x - half, y - half], [x + half, y - half],
      [x - half, y + half], [x + half, y + half]
    ].every(([cornerX, cornerY]) => Math.hypot(cornerX - 0.5, cornerY - 0.5) <= radius);
  }

  function constrainedCenter(x, y, scale = state.scale) {
    const radius = activePrintRadius();
    const edge = 0.5 - radius;
    const half = DEFAULT_QR_SIZE * scale / 2;
    let targetX = clamp(Number(x) || 0.5, edge + half, 1 - edge - half);
    let targetY = clamp(Number(y) || 0.5, edge + half, 1 - edge - half);
    if (squareFits(targetX, targetY, half, radius)) return { x: targetX, y: targetY };
    const dx = targetX - 0.5;
    const dy = targetY - 0.5;
    let low = 0;
    let high = 1;
    for (let index = 0; index < 28; index += 1) {
      const factor = (low + high) / 2;
      if (squareFits(0.5 + dx * factor, 0.5 + dy * factor, half, radius)) low = factor;
      else high = factor;
    }
    return { x: 0.5 + dx * low, y: 0.5 + dy * low };
  }

  function constrainState() {
    state.scale = clamp(Number(state.scale) || 1, 0.5, 1.5);
    const next = constrainedCenter(state.x, state.y, state.scale);
    state.x = next.x;
    state.y = next.y;
  }

  function targetsX() {
    if (!state.visible) return [0.5];
    const bounds = qrProtectionBounds();
    const edge = activePrintEdge();
    return [(edge + bounds.left) / 2, 0.5, (bounds.right + 1 - edge) / 2];
  }

  function targetsY() {
    if (!state.visible) return [0.5];
    const bounds = qrProtectionBounds();
    const edge = activePrintEdge();
    return [(edge + bounds.top) / 2, 0.5, (bounds.bottom + 1 - edge) / 2];
  }

  function ensureLines() {
    const nextStage = stage();
    if (!nextStage) return null;
    if (lineX?.isConnected && lineY?.isConnected && currentStage === nextStage) {
      updateSafeZoneRing();
      return { lineX, lineY };
    }
    overlay?.remove();
    overlay = document.createElement('div');
    overlay.dataset.smoofAlignmentGuideOverlay = 'true';
    Object.assign(overlay.style, {
      position: 'absolute', inset: '0', zIndex: '2147483000', pointerEvents: 'none', overflow: 'hidden'
    });
    lineX = document.createElement('div');
    lineX.dataset.smoofAlignmentGuide = 'x';
    lineX.setAttribute('aria-hidden', 'true');
    Object.assign(lineX.style, {
      position: 'absolute', display: 'none', top: `${PRINT_EDGE * 100}%`, bottom: `${PRINT_EDGE * 100}%`,
      width: '1px', transform: 'translateX(-0.5px)', background: '#19a7ff',
      boxShadow: '0 0 0 1px rgba(255,255,255,.82), 0 0 5px rgba(25,167,255,.82)'
    });
    lineY = document.createElement('div');
    lineY.dataset.smoofAlignmentGuide = 'y';
    lineY.setAttribute('aria-hidden', 'true');
    Object.assign(lineY.style, {
      position: 'absolute', display: 'none', left: `${PRINT_EDGE * 100}%`, right: `${PRINT_EDGE * 100}%`,
      height: '1px', transform: 'translateY(-0.5px)', background: '#19a7ff',
      boxShadow: '0 0 0 1px rgba(255,255,255,.82), 0 0 5px rgba(25,167,255,.82)'
    });
    safeZoneRing = document.createElement('div');
    safeZoneRing.dataset.smoofLaserSafeZone = 'true';
    safeZoneRing.setAttribute('aria-hidden', 'true');
    Object.assign(safeZoneRing.style, {
      position: 'absolute', display: 'none', border: '1px dashed rgba(180, 92, 0, .72)',
      borderRadius: '50%', boxSizing: 'border-box', pointerEvents: 'none'
    });
    overlay.append(safeZoneRing, lineX, lineY);
    nextStage.appendChild(overlay);
    currentStage = nextStage;
    updateSafeZoneRing();
    return { lineX, lineY };
  }

  function updateSafeZoneRing() {
    if (!safeZoneRing) return;
    const margin = activeLaserMarginMm();
    const radius = activePrintRadius();
    const visible = margin > 0 && guidesVisible();
    safeZoneRing.style.display = visible ? 'block' : 'none';
    safeZoneRing.style.left = `${(0.5 - radius) * 100}%`;
    safeZoneRing.style.top = `${(0.5 - radius) * 100}%`;
    safeZoneRing.style.width = `${radius * 200}%`;
    safeZoneRing.style.height = `${radius * 200}%`;
    safeZoneRing.title = visible ? `Laser-Sicherheitsrand ${margin} mm` : '';
  }

  function nearest(value, targets, threshold = THRESHOLD) {
    const number = Number(value);
    if (!Number.isFinite(number)) return null;
    const candidate = targets.map(target => ({ target, distance: Math.abs(target - number) }))
      .sort((a, b) => a.distance - b.distance)[0];
    return candidate?.distance <= Number(threshold) ? candidate.target : null;
  }

  const nearestX = (value, threshold = THRESHOLD) => axisEnabled('x') ? nearest(value, targetsX(), threshold) : null;
  const nearestY = (value, threshold = THRESHOLD) => axisEnabled('y') ? nearest(value, targetsY(), threshold) : null;

  function showX(value) {
    if (!axisEnabled('x')) { hideX(); return false; }
    const line = ensureLines()?.lineX;
    if (!line || !Number.isFinite(Number(value))) return false;
    line.style.left = `${Number(value) * 100}%`;
    line.style.display = 'block';
    return true;
  }

  function showY(value) {
    if (!axisEnabled('y')) { hideY(); return false; }
    const line = ensureLines()?.lineY;
    if (!line || !Number.isFinite(Number(value))) return false;
    line.style.top = `${Number(value) * 100}%`;
    line.style.display = 'block';
    return true;
  }

  function hideX() { if (lineX) lineX.style.display = 'none'; }
  function hideY() { if (lineY) lineY.style.display = 'none'; }
  function hideAll() { hideX(); hideY(); }

  function suppressNativeQr() {
    const stages = Array.isArray(window.Konva?.stages) ? window.Konva.stages : [];
    stages.forEach(konvaStage => {
      let images = [];
      try { images = konvaStage.find?.('Image') || []; } catch (error) { images = []; }
      images.forEach(node => {
        const image = node.image?.() || node.attrs?.image;
        const source = String(image?.currentSrc || image?.src || node.attrs?.src || '');
        if (!QR_SOURCE_MARKERS.some(marker => source.includes(marker))) return;
        node.visible?.(false);
        node.getLayer?.()?.batchDraw?.();
      });
    });
  }

  /*
   * Der Proof-Downloader hält für die alte, fest zentrierte QR-Vorschau eine
   * eigene DOM-Hintergrundfläche vor. Seit der QR verschiebbar ist, darf diese
   * Fläche nicht an ihrer ursprünglichen Position stehen bleiben. Wir führen
   * sie deshalb deckungsgleich mit der neuen QR-Ebene. So bleibt die bestehende
   * Proof-Logik unangetastet, während im Editor keine zweite weiße Fläche mehr
   * sichtbar wird.
   */
  function syncLegacyWhitePanel(bounds = qrBounds()) {
    document.querySelectorAll('[data-smoof-qr-white-panel]').forEach(panel => {
      panel.style.setProperty('display', backingVisible() ? 'block' : 'none', 'important');
      panel.style.setProperty('background', backingVisible() ? backingColor() : 'transparent', 'important');
      panel.style.setProperty('left', `${bounds.left * 100}%`, 'important');
      panel.style.setProperty('top', `${bounds.top * 100}%`, 'important');
      panel.style.setProperty('width', `${bounds.width * 100}%`, 'important');
      panel.style.setProperty('height', `${bounds.height * 100}%`, 'important');
    });
  }

  function ensureQrFrame() {
    const target = stage();
    if (!target) return null;
    if (qrFrame?.isConnected && qrFrame.parentNode === target) return qrFrame;
    qrFrame?.remove();
    qrFrame = document.createElement('button');
    qrFrame.type = 'button';
    qrFrame.dataset.smoofQrFrame = 'true';
    qrFrame.dataset.smoofEditorItem = 'qr';
    qrFrame.setAttribute('aria-label', document.documentElement.lang?.startsWith('en') ? 'Move or resize QR code' : 'QR-Code verschieben oder skalieren');
    Object.assign(qrFrame.style, {
      position: 'absolute', margin: '0', padding: '0', border: '1.5px dashed transparent',
      borderRadius: '7%', background: backingVisible() ? backingColor() : 'transparent', overflow: 'hidden', cursor: 'move',
      touchAction: 'none', zIndex: '2147482400', boxSizing: 'border-box'
    });
    qrImage = document.createElement('span');
    qrImage.setAttribute('aria-hidden', 'true');
    Object.assign(qrImage.style, {
      position: 'absolute', width: `${100 / DEFAULT_QR_SIZE}%`, height: `${100 / DEFAULT_QR_SIZE}%`,
      maxWidth: 'none', left: '50%', top: '50%', transform: 'translate(-50%, -50%)',
      backgroundColor: renderedCodeColor(),
      maskImage: `url("${QR_IMAGE_URL}")`,
      WebkitMaskImage: `url("${QR_IMAGE_URL}")`,
      maskPosition: 'center', WebkitMaskPosition: 'center',
      maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat',
      maskSize: '100% 100%', WebkitMaskSize: '100% 100%',
      pointerEvents: 'none', userSelect: 'none'
    });
    qrFrame.appendChild(qrImage);
    qrFrame.addEventListener('pointerdown', startQrDrag);
    qrFrame.addEventListener('pointermove', moveQrDrag);
    qrFrame.addEventListener('pointerup', endQrDrag);
    qrFrame.addEventListener('pointercancel', endQrDrag);
    qrFrame.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      if (!dragMoved) window.dispatchEvent(new CustomEvent('smoof:editor-select', { detail: { id: 'qr' } }));
      dragMoved = false;
    });
    target.appendChild(qrFrame);
    updateQrFrame();
    return qrFrame;
  }

  function updateQrFrame() {
    const frame = ensureQrFrame();
    if (!frame) return;
    const bounds = qrBounds();
    frame.style.left = `${bounds.left * 100}%`;
    frame.style.top = `${bounds.top * 100}%`;
    frame.style.width = `${bounds.width * 100}%`;
    frame.style.height = `${bounds.height * 100}%`;
    frame.style.display = state.visible || backingVisible() ? 'block' : 'none';
    frame.style.background = backingVisible() ? backingColor() : 'transparent';
    const tight = !configuredBackingVisible();
    // The original image is sized against the panel's content box, excluding
    // its two 1.5px borders. Preserve that exact image size when changing the
    // hit box; using only a smaller percentage would also shrink the code.
    frame.style.borderWidth = `${QR_FRAME_BORDER}px`;
    const panelBorder = parseFloat(getComputedStyle(frame).borderLeftWidth) || 0;
    const borderInset = 2 * panelBorder * QR_ARTWORK_SIZE / DEFAULT_QR_SIZE;
    if (tight) {
      const half = QR_ARTWORK_SIZE * state.scale / 2;
      frame.style.left = `calc(${(state.x - half) * 100}% + ${borderInset / 2}px)`;
      frame.style.top = `calc(${(state.y - half) * 100}% + ${borderInset / 2}px)`;
      frame.style.width = `calc(${QR_ARTWORK_SIZE * state.scale * 100}% - ${borderInset}px)`;
      frame.style.height = `calc(${QR_ARTWORK_SIZE * state.scale * 100}% - ${borderInset}px)`;
    }
    frame.style.borderWidth = tight ? '0px' : `${QR_FRAME_BORDER}px`;
    frame.style.borderRadius = tight ? '0px' : '7%';
    frame.style.outline = tight && selected ? '1.5px dashed #19a7ff' : 'none';
    if (qrImage) {
      qrImage.style.width = `${100 / (tight ? QR_ARTWORK_SIZE : DEFAULT_QR_SIZE)}%`;
      qrImage.style.height = qrImage.style.width;
      qrImage.style.display = state.visible ? 'block' : 'none';
      qrImage.style.backgroundColor = renderedCodeColor();
    }
    frame.style.borderColor = selected ? '#19a7ff' : 'transparent';
    frame.style.boxShadow = selected ? '0 0 0 1px rgba(255,255,255,.9)' : 'none';
    frame.dataset.selected = selected ? 'true' : 'false';
    syncLegacyWhitePanel(bounds);
    suppressNativeQr();
  }

  function startQrDrag(event) {
    if (event.button !== 0) return;
    dragging = true;
    dragMoved = false;
    dragStart = { clientX: event.clientX, clientY: event.clientY, x: state.x, y: state.y };
    qrFrame?.setPointerCapture?.(event.pointerId);
    event.preventDefault();
    event.stopPropagation();
  }

  function moveQrDrag(event) {
    if (!dragging || !dragStart) return;
    const rect = stage()?.getBoundingClientRect();
    if (!rect?.width || !rect?.height) return;
    const dx = (event.clientX - dragStart.clientX) / rect.width;
    const dy = (event.clientY - dragStart.clientY) / rect.height;
    dragMoved = dragMoved || Math.abs(dx) + Math.abs(dy) > 0.002;
    const next = constrainedCenter(dragStart.x + dx, dragStart.y + dy);
    state.x = next.x;
    state.y = next.y;
    const snapX = axisEnabled('x') ? nearest(state.x, [0.5], THRESHOLD) : null;
    const snapY = axisEnabled('y') ? nearest(state.y, [0.5], THRESHOLD) : null;
    if (Number.isFinite(snapX)) { state.x = snapX; showX(snapX); } else hideX();
    if (Number.isFinite(snapY)) { state.y = snapY; showY(snapY); } else hideY();
    updateQrFrame();
    dispatchChange(false);
    event.preventDefault();
    event.stopPropagation();
  }

  function endQrDrag(event) {
    if (!dragging) return;
    dragging = false;
    dragStart = null;
    hideAll();
    qrFrame?.releasePointerCapture?.(event.pointerId);
    saveState();
    dispatchChange(true);
    event.preventDefault();
    event.stopPropagation();
  }

  function dispatchChange(commit = false, previous = null) {
    const detail = { current: getState(), previous, commit };
    window.dispatchEvent(new CustomEvent('smoof:qr-geometry-change', { detail }));
    if (commit) window.dispatchEvent(new CustomEvent('smoof:history-commit', { detail: { source: 'qr' } }));
    window.SmoofDesignRenderer?.scheduleRender?.();
  }

  function getState() {
    return {
      x: state.x,
      y: state.y,
      scale: state.scale,
      size: qrSize(),
      visible: state.visible,
      codeColor: codeColor(),
      backingVisible: configuredBackingVisible(),
      backingColor: backingColor()
    };
  }

  function applyState(next, { commit = true } = {}) {
    if (!next || typeof next !== 'object') return false;
    const previous = getState();
    if (Number.isFinite(Number(next.x))) state.x = Number(next.x);
    if (Number.isFinite(Number(next.y))) state.y = Number(next.y);
    if (Number.isFinite(Number(next.scale))) state.scale = Number(next.scale);
    if (typeof next.visible === 'boolean') state.visible = next.visible;
    if (next.codeColor != null) {
      state.codeColor = normalizeColor(next.codeColor, state.codeColor);
    }
    if (!profileForcesTransparentBacking()) {
      if (typeof next.backingVisible === 'boolean') {
        state.backingVisible = next.backingVisible;
      } else if (typeof next.whiteBackground === 'boolean') {
        state.backingVisible = next.whiteBackground;
      }
    } else {
      state.backingVisible = false;
    }
    if (next.backingColor != null) {
      state.backingColor = normalizeColor(next.backingColor, state.backingColor);
    }
    constrainState();
    saveState();
    updateQrFrame();
    dispatchChange(commit, previous);
    return true;
  }

  const reset = () => applyState({ x: 0.5, y: 0.5, scale: 1 });

  const resetAll = () => applyState({
    x: 0.5,
    y: 0.5,
    scale: 1,
    visible: true,
    codeColor: '#000000',
    backingVisible: !profileForcesTransparentBacking(),
    backingColor: '#FFFFFF'
  });

  function qrWouldOverlapVisibleItems() {
    const target = stage();
    if (!target) return false;
    const stageRect = target.getBoundingClientRect();
    if (!stageRect.width || !stageRect.height) return false;
    const bounds = qrProtectionBounds(0.004);
    const qrRect = {
      left: stageRect.left + bounds.left * stageRect.width,
      right: stageRect.left + bounds.right * stageRect.width,
      top: stageRect.top + bounds.top * stageRect.height,
      bottom: stageRect.top + bounds.bottom * stageRect.height
    };
    return Array.from(target.querySelectorAll('[data-smoof-editor-item]')).some(item => {
      const id = String(item.dataset.smoofEditorItem || '');
      if (!id || ['qr', 'background', 'modern-ui-control'].includes(id)) return false;
      const style = getComputedStyle(item);
      const rect = item.getBoundingClientRect();
      if (item.hidden || style.display === 'none' || style.visibility === 'hidden' || rect.width < 2 || rect.height < 2) return false;
      return rect.right > qrRect.left && rect.left < qrRect.right && rect.bottom > qrRect.top && rect.top < qrRect.bottom;
    });
  }

  function setVisible(visible, { warnOnOverlap = true } = {}) {
    const nextVisible = Boolean(visible);
    if (nextVisible === state.visible) return true;
    if (
      nextVisible &&
      warnOnOverlap &&
      qrWouldOverlapVisibleItems() &&
      !window.confirm(
        document.documentElement.lang?.startsWith('en')
          ? 'Another element currently occupies the QR protection zone. Show the QR code anyway? Please reposition overlapping content before production.'
          : 'Ein anderes Element belegt aktuell die QR-Schutzzone. QR-Code trotzdem einblenden? Bitte verschiebe überlappende Inhalte vor der Produktion.'
      )
    ) {
      return false;
    }
    return applyState({ visible: nextVisible });
  }

  function setBackingVisible(visible) {
    if (profileForcesTransparentBacking()) return false;
    return applyState({ backingVisible: Boolean(visible) });
  }

  function setBackingColor(color, { commit = true } = {}) {
    const normalized = normalizeColor(color, '');
    if (!normalized || profileForcesTransparentBacking()) return false;
    return applyState({ backingColor: normalized }, { commit });
  }

  function setCodeColor(color, { commit = true } = {}) {
    const normalized = normalizeColor(color, '');
    if (!normalized) return false;
    return applyState({ codeColor: normalized }, { commit });
  }

  /*
   * Zentrale Positions-API fuer alle frei beweglichen Editorobjekte.
   * Die Module uebergeben nur noch Mittelpunkt und bereits rotierte
   * Halbausdehnung. Druckkreis und aktuelle QR-Geometrie werden hier
   * einheitlich ausgewertet.
   */
  function constrainRect(options = {}) {
    const requestedRadius = Number(options.radius);
    const policyRadius = activePrintRadius();
    /*
     * Nur Piktogramm-Editoren duerfen ihren explizit uebergebenen Radius
     * ausserhalb des Druckkreises nutzen. Bei aktiver Laser-Randzone bleibt
     * die zentrale Produktsicherheitsregel immer massgeblich.
     */
    const allowOutsidePrintRadius =
      options.allowOutsidePrintRadius === true &&
      activeLaserMarginMm() <= 0;
    const radius = Math.max(
      0.01,
      Number.isFinite(requestedRadius)
        ? (allowOutsidePrintRadius ? requestedRadius : Math.min(requestedRadius, policyRadius))
        : policyRadius
    );
    const halfWidth = Math.max(0, Number(options.halfWidth) || 0);
    const halfHeight = Math.max(0, Number(options.halfHeight) || 0);
    const wanted = {
      x: Number.isFinite(Number(options.x)) ? Number(options.x) : 0.5,
      y: Number.isFinite(Number(options.y)) ? Number(options.y) : 0.5
    };
    const allowQrOverlap = options.allowQrOverlap === true || !state.visible;
    const padding = Number.isFinite(Number(options.qrPadding))
      ? Number(options.qrPadding)
      : 0.004;
    const qr = qrProtectionBounds(padding);
    const sizeFitsCircle = Math.hypot(halfWidth, halfHeight) <= radius;

    const projectToCircle = (point, firstAxis) => {
      let dx = point.x - 0.5;
      let dy = point.y - 0.5;
      const clampX = () => {
        const remaining = radius ** 2 - (Math.abs(dy) + halfHeight) ** 2;
        const maximum = Math.max(0, Math.sqrt(Math.max(0, remaining)) - halfWidth);
        dx = clamp(dx, -maximum, maximum);
      };
      const clampY = () => {
        const remaining = radius ** 2 - (Math.abs(dx) + halfWidth) ** 2;
        const maximum = Math.max(0, Math.sqrt(Math.max(0, remaining)) - halfHeight);
        dy = clamp(dy, -maximum, maximum);
      };
      for (let index = 0; index < 4; index += 1) {
        if (firstAxis === 'x') {
          clampX();
          clampY();
        } else {
          clampY();
          clampX();
        }
      }
      return { x: 0.5 + dx, y: 0.5 + dy };
    };

    const withinCircle = point => {
      const xFirst = projectToCircle(point, 'x');
      const yFirst = projectToCircle(point, 'y');
      const xDistance = Math.hypot(xFirst.x - point.x, xFirst.y - point.y);
      const yDistance = Math.hypot(yFirst.x - point.x, yFirst.y - point.y);
      return xDistance <= yDistance ? xFirst : yFirst;
    };

    const overlapsQr = point =>
      point.x + halfWidth > qr.left &&
      point.x - halfWidth < qr.right &&
      point.y + halfHeight > qr.top &&
      point.y - halfHeight < qr.bottom;

    const circlePosition = withinCircle(wanted);
    if (allowQrOverlap || !overlapsQr(circlePosition)) {
      return {
        ...circlePosition,
        adjusted: circlePosition.x !== wanted.x || circlePosition.y !== wanted.y,
        blockedByQr: false,
        valid: sizeFitsCircle,
        radius,
        edgeMarginMm: activeLaserMarginMm(),
        qr
      };
    }

    const epsilon = 0.000001;
    const candidates = [];
    const addVerticalCandidate = x => {
      const remaining = radius ** 2 - (Math.abs(x - 0.5) + halfWidth) ** 2;
      if (remaining < 0) return;
      const span = Math.max(0, Math.sqrt(Math.max(0, remaining)) - halfHeight);
      candidates.push({ x, y: clamp(wanted.y, 0.5 - span, 0.5 + span) });
    };
    const addHorizontalCandidate = y => {
      const remaining = radius ** 2 - (Math.abs(y - 0.5) + halfHeight) ** 2;
      if (remaining < 0) return;
      const span = Math.max(0, Math.sqrt(Math.max(0, remaining)) - halfWidth);
      candidates.push({ x: clamp(wanted.x, 0.5 - span, 0.5 + span), y });
    };

    addVerticalCandidate(qr.left - halfWidth - epsilon);
    addVerticalCandidate(qr.right + halfWidth + epsilon);
    addHorizontalCandidate(qr.top - halfHeight - epsilon);
    addHorizontalCandidate(qr.bottom + halfHeight + epsilon);

    const validCandidates = candidates
      .filter(candidate => !overlapsQr(candidate))
      .sort((a, b) =>
        Math.hypot(a.x - wanted.x, a.y - wanted.y) -
        Math.hypot(b.x - wanted.x, b.y - wanted.y)
      );
    const best = validCandidates[0] || circlePosition;

    return {
      ...best,
      adjusted: true,
      blockedByQr: true,
      valid: sizeFitsCircle && validCandidates.length > 0,
      radius,
      edgeMarginMm: activeLaserMarginMm(),
      qr
    };
  }

  function rotatedHalfExtents(width, height, rotation = 0) {
    const radians = Math.abs(Number(rotation) || 0) * Math.PI / 180;
    const halfWidth = Math.max(0, Number(width) || 0) / 2;
    const halfHeight = Math.max(0, Number(height) || 0) / 2;
    return {
      halfWidth: Math.abs(Math.cos(radians)) * halfWidth + Math.abs(Math.sin(radians)) * halfHeight,
      halfHeight: Math.abs(Math.sin(radians)) * halfWidth + Math.abs(Math.cos(radians)) * halfHeight
    };
  }

  window.SmoofAlignmentGuides = Object.freeze({
    isAxisEnabled: axisEnabled,
    setAxisEnabled,
    getPreferences: () => ({ ...snapAxes }),
    get targets() { return targetsX(); },
    get targetsX() { return targetsX(); },
    get targetsY() { return targetsY(); },
    threshold: THRESHOLD,
    nearestX,
    nearestY,
    showX,
    showY,
    hideX,
    hideY,
    hideAll,
    snapX(value, threshold = THRESHOLD) {
      const target = nearestX(value, threshold);
      Number.isFinite(target) ? showX(target) : hideX();
      return target;
    },
    snapY(value, threshold = THRESHOLD) {
      const target = nearestY(value, threshold);
      Number.isFinite(target) ? showY(target) : hideY();
      return target;
    }
  });

  window.SmoofQrGeometryTools = Object.freeze({
    nudge(dx, dy) {
      if (!state.visible) return false;
      return applyState({ x: state.x + dx, y: state.y + dy }, { commit: false });
    },
    version: '2.36.0',
    getState,
    getHistoryState: getState,
    applyState,
    applyHistoryState(next) { return applyState(next, { commit: false }); },
    setScale(scale) { return applyState({ scale }); },
    isVisible() { return state.visible; },
    setVisible,
    toggleVisibility() { return setVisible(!state.visible); },
    setCodeColor,
    isCodeColorLocked: laserForcesBlackQr,
    isBackingVisible: backingVisible,
    setBackingVisible,
    toggleBackingVisibility() { return setBackingVisible(!configuredBackingVisible()); },
    setBackingColor,
    isBackingLocked: profileForcesTransparentBacking,
    reset,
    getBounds: qrBounds,
    sizeMm(diameterMm) {
      const diameter = Number(diameterMm) || 80;
      return qrSize() / (PRINT_RADIUS * 2) * diameter;
    }
  });

  window.SmoofSpatialConstraints = Object.freeze({
    version: '1.4.0',
    get printRadius() { return activePrintRadius(); },
    get physicalPrintRadius() { return PRINT_RADIUS; },
    get edgeMarginMm() { return activeLaserMarginMm(); },
    get isLaserMarginActive() { return activeLaserMarginMm() > 0; },
    getQrBounds: qrProtectionBounds,
    rotatedHalfExtents,
    constrainRect
  });

  window.dispatchEvent(new CustomEvent('smoof:spatial-constraints-ready'));

  function scheduleMount() {
    requestAnimationFrame(() => {
      observeGuideVisibility();
      ensureLines();
      ensureQrFrame();
      updateQrFrame();
    });
    clearTimeout(suppressionTimer);
    suppressionTimer = setTimeout(suppressNativeQr, 180);
  }

  loadState();
  saveState();
  document.addEventListener('pointerup', hideAll, true);
  document.addEventListener('pointercancel', hideAll, true);
  window.addEventListener('blur', hideAll);
  window.addEventListener('resize', scheduleMount);
  window.addEventListener('smoof:product-variant-change', () => {
    const previous = getState();
    constrainState();
    saveState();
    updateQrFrame();
    dispatchChange(true, previous);
    window.dispatchEvent(new CustomEvent('smoof:spatial-constraints-changed', {
      detail: {
        radius: activePrintRadius(),
        physicalRadius: PRINT_RADIUS,
        edgeMarginMm: activeLaserMarginMm(),
        diameterMm: currentDiameterMm()
      }
    }));
    scheduleMount();
  });
  window.addEventListener('smoof:editor-reset-layout', reset);
  window.addEventListener('smoof:editor-reset-all', resetAll);
  window.addEventListener('smoof:editor-select', event => {
    selected = String(event.detail?.id || '') === 'qr';
    updateQrFrame();
    if (!event.detail?.id) hideAll();
  });
  new MutationObserver(scheduleMount).observe(document.body, { childList: true, subtree: true });
  scheduleMount();
})();
